import axios from "axios";
import { configureUrl } from "../lib/helper";
import { toast } from "react-toastify";

const isPublicAuthEndpoint = (url) => {
  if (!url) return false;
  return (
    url.includes("/auth/login") ||
    url.includes("/auth/agent-login") ||
    url.includes("/auth/logout") ||
    url.includes("/auth/forgot-password") ||
    url.includes("/auth/reset-password") ||
    url.includes("/verifyEmailOtp") ||
    url.includes("/verifyEmailOtpLogin") ||
    url.includes("/resendEmailOtp")
  );
};

const logoutAndRedirect = (message) => {
  toast.error(message || "Session expired. Please log in again.");
  try {
    localStorage.clear();
  } catch (error) {}
  window.location = "/";
};

axios.interceptors.request.use(
  async (config) => {
    let request = config;
    let token = "";
    if (!token) {
      token = localStorage.getItem("token");
    }
    request.headers = token
      ? {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
          ...request.headers
        }
      : {
          "Content-Type": "application/json",
          Accept: "application/json",
          ...request.headers
        };
    request.url = configureUrl(config.url);
    return request;
  },
  (error) => {
    throw error.response;
  }
);

axios.interceptors.response.use(
  (response) => {
    checkTokenIsValid(response);
    return response;
  },
  (error) => errorHandler(error)
);

const checkTokenIsValid = (response) => {
  const url = response?.config?.url;
  if (response?.status === 401 && !isPublicAuthEndpoint(url)) {
    logoutAndRedirect("Session expired. Please log in again.");
  }
};

const errorHandler = async (error) => {
  const url = error?.response?.config?.url;
  if (error?.response?.status == 401 && !isPublicAuthEndpoint(url)) {
    logoutAndRedirect("Session expired. Please log in again.");
  }
  throw error.response;
};

const agentAxios = axios.create({});

export default agentAxios;

agentAxios.interceptors.request.use(
  async (config) => {
    let request = config;
    let token = "";
    if (!token) {
      token = localStorage.getItem("agent_token");
    }
    request.headers = token
      ? {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
          ...request.headers
        }
      : {
          "Content-Type": "application/json",
          Accept: "application/json",
          ...request.headers
        };
    request.url = configureUrl(config.url);
    return request;
  },
  (error) => {
    throw error.response;
  }
);

agentAxios.interceptors.response.use(
  (response) => {
    checkAgentTokenIsValid(response);
    return response;
  },
  (error) => errorHandlerAgent(error)
);

const checkAgentTokenIsValid = (response) => {
  const url = response?.config?.url;
  if (response?.status == 401 && !isPublicAuthEndpoint(url)) {
    logoutAndRedirect("Session expired. Please log in again.");
  }
};

const errorHandlerAgent = async (error) => {
  const url = error?.response?.config?.url;
  if (error?.response?.status == 401 && !isPublicAuthEndpoint(url)) {
    logoutAndRedirect("Session expired. Please log in again.");
  }
  throw error.response;
};
